import React, { useState } from "react";
import HoverToDisplayFullTitle from "../../reusableComponents/HoverToDisplayFullTitle";
import { useAuth } from "../../context/API_Client";
import { sortDateTime } from "../utils/utils";

export function ProductsSchema(
  handleEdit,
  handleDelete,
  operationPermissions,
  externalProduct
) {
  const { isAuthorizedPermission } = useAuth();
  return {
    metadata: {
      title: "Business Units",
      minHeight: "68vh",
      position: "relative",
      showTitle: false,
      rowHeight: 60,
      defaultSortInfo: { name: "addedDTime", dir: -1 },
    },
    fields: [
      {
        name: "name",
        header: "Name",
        visible: true,
        type: "string",
        filtering: false,
        textAlign: "center",
        minWidth: 200,
        defaultFlex: 1,
        sortable: false,

        render: ({ data }) => {
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data?.name && (
                <HoverToDisplayFullTitle title={data?.name} len={22} />
              )}
            </span>
          );
        },
      },
      {
        name: "code",
        header: "Code",
        visible: true,
        type: "string",
        filtering: false,
        textAlign: "center",
        minWidth: 140,
        defaultFlex: 1,
        sortable: false,
        defaultWidth: 40,
        render: ({ data }) => {
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data?.code && (
                <HoverToDisplayFullTitle title={data?.code} len={10} />
              )}
            </span>
          );
        },
      },
      {
        name: "addedDTime",
        header: "Created At",
        visible: true,
        type: "datetime",
        filtering: false,
        textAlign: "center",
        minWidth: 220,
        defaultWidth: 320,
        defaultFlex: 1,
        sort: sortDateTime,
        render: ({ data }) => {
          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {data?.addedDTime}
            </span>
          );
        },
      },
      {
        name: "businessUnits",
        header: "Business Unit",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 200,
        textAlign: "center",
        sortable: false,
        defaultFlex: 1,
        render: ({ data }) => {
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data?.businessUnits && (
                <HoverToDisplayFullTitle title={data?.businessUnits} len={22} />
              )}
            </span>
          );
        },
      },
      {
        name: "currencyCode",
        header: "Currency",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 150,
        textAlign: "center",
        sortable: false,
        defaultFlex: 1,
        render: ({ data }) => {
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data?.currencyCode && (
                <HoverToDisplayFullTitle title={data?.currencyCode} len={32} />
              )}
            </span>
          );
        },
      },
      {
        name: "minAmount",
        header: "Minimum Amount",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 200,
        textAlign: "center",
        sortable: false,
        defaultFlex: 1,
        render: ({ data }) => {
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data?.minAmount && (
                <HoverToDisplayFullTitle title={data?.minAmount} len={32} />
              )}
            </span>
          );
        },
      },
      {
        name: "maxAmount",
        header: "Maximum Amount",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 200,
        textAlign: "center",
        sortable: false,
        defaultFlex: 1,
        render: ({ data }) => {
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data?.maxAmount && (
                <HoverToDisplayFullTitle title={data?.maxAmount} len={32} />
              )}
            </span>
          );
        },
      },
      {
        name: "description",
        header: "Description",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 200,
        defaultWidth: 180,
        textAlign: "center",
        sortable: false,
        defaultFlex: 4,
        render: ({ data }) => {
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data?.description && (
                <HoverToDisplayFullTitle title={data?.description} len={22} />
              )}
            </span>
          );
        },
      },

      {
        name: "actions",
        header: "Actions",
        visible:
          isAuthorizedPermission(operationPermissions?.updateProduct) ||
          isAuthorizedPermission(operationPermissions?.deleteProduct)
            ? true
            : false,
        type: "string",
        filtering: false,
        minWidth: 120,
        defaultFlex: 1,
        textAlign: "center",
        alignItems: "center",
        sortable: false,
        visible: !externalProduct,
        render: ({ data }) => (
          <div
            style={{
              marginLeft: "-12px",
              maxWidth: "40px",
            }}
          >
            <div style={{ display: "flex", gap: "8px" }}>
              {isAuthorizedPermission(operationPermissions?.updateProduct) && (
                <img
                  src="/assets/routingIcons/Edit-icon.svg"
                  className="edit-icon"
                  onClick={() => handleEdit(data)}
                />
              )}
              {isAuthorizedPermission(operationPermissions?.deleteProduct) && (
                <img
                  src="/assets/routingIcons/DeleteOutlinedIcon.svg"
                  className="delete-icon"
                  onClick={() => handleDelete(data?.code)}
                />
              )}
            </div>
          </div>
        ),
      },
    ],
  };
}
